export default __webpack_public_path__ + "static/media/profile.70d9b5b4.png";